/* ===========================================================
   DESKARIS — script commun des sections DSK.

   1. Apparition au scroll (.dsk__rev)
   2. Vignettes sous les galeries + filtrage des photos par variante
      (et photo #tapissupport réservée à la formule Tapis + support)
   3. Synchronisation des formulaires secondaires avec la variante choisie
   =========================================================== */

(function () {
  if (window.__dskRev) return;
  window.__dskRev = true;

  document.documentElement.classList.add('dsk-anim');

  var editeur = !!(window.Shopify && window.Shopify.designMode);
  var peutObserver = ('IntersectionObserver' in window);
  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var direct = editeur || reduit || !peutObserver;

  var io = null;
  if (!direct) {
    io = new IntersectionObserver(function (entrees) {
      for (var i = 0; i < entrees.length; i++) {
        if (entrees[i].isIntersecting) {
          entrees[i].target.classList.add('dsk--on');
          io.unobserve(entrees[i].target);
        }
      }
    }, { threshold: .1, rootMargin: '0px 0px -40px 0px' });
  }

  function traiter(el) {
    if (!el || !el.classList || el.classList.contains('dsk--on')) return;
    if (direct) { el.classList.add('dsk--on'); return; }
    if (el.dataset.dskObs) return;
    el.dataset.dskObs = '1';
    io.observe(el);
    var r = el.getBoundingClientRect();
    if (r.top < (window.innerHeight || 0) && r.bottom > 0) el.classList.add('dsk--on');
  }

  function scanner(racine) {
    var base = (racine && racine.querySelectorAll) ? racine : document;
    if (base.classList && base.classList.contains('dsk__rev')) traiter(base);
    var els = base.querySelectorAll('.dsk__rev');
    for (var i = 0; i < els.length; i++) traiter(els[i]);
    galeries(base);
  }

  /* ---------- filtrage ---------- */

  function nettoie(s) {
    return (s || '').toString().toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  var neutres = ['benefice', 'benefices', 'dimension', 'dimensions', 'avis', 'avantapres', 'avant-apres', 'kit', 'video'];

  function tagsDe(fig) {
    var brut = fig.getAttribute('data-tags');
    if (brut === null) {
      var img = fig.querySelector('img');
      brut = img ? (img.getAttribute('alt') || '') : '';
    }
    var trouves = brut.match(/#[^\s#]+/g) || [];
    var liste = [];
    for (var i = 0; i < trouves.length; i++) {
      var t = nettoie(trouves[i].slice(1));
      if (t) liste.push(t);
    }
    return liste;
  }

  function etat(sec) {
    var choisis = sec.querySelectorAll('input[name="dskO0"]:checked, input[name="dskO1"]:checked');
    var sel = [];
    for (var i = 0; i < choisis.length; i++) sel.push(nettoie(choisis[i].value));
    var s = sel.join(' ');
    if (!s) return null;
    return {
      pack: s.indexOf('vide-poche') > -1 || s.indexOf('pack') > -1,
      coul: (s.indexOf('gris') > -1 || s.indexOf('beige') > -1) ? 'gris' : (s.indexOf('noir') > -1 ? 'noir' : '')
    };
  }

  function visible(tags, e) {
    if (!tags.length) return true;
    for (var i = 0; i < tags.length; i++) {
      var t = tags[i];
      if (neutres.indexOf(t) > -1) return true;
      if (t === 'visuel') { if (e.pack) return false; continue; }
      if (t === 'noir') { if (e.pack || e.coul !== 'noir') return false; continue; }
      if (t === 'gris' || t === 'beige') { if (e.pack || e.coul !== 'gris') return false; continue; }
      if (t === 'packnoir') { if (!e.pack || e.coul !== 'noir') return false; continue; }
      if (t === 'packgris' || t === 'packbeige') { if (!e.pack || e.coul !== 'gris') return false; continue; }
      if (t === 'pack' || t === 'bundle') { if (!e.pack) return false; continue; }
    }
    return true;
  }

  /* Photo réservée à la formule « Tapis + support » (texte alternatif #tapissupport). */
  function estSolo(fig) {
    return fig.hasAttribute('data-solo') || tagsDe(fig).indexOf('tapissupport') > -1;
  }

  function duoChoisi(sec) {
    return !!sec.querySelector('input[name^="dskPack-"][value="pack"]:checked');
  }

  function filtrer(gal, sec) {
    if (!gal || !sec) return;
    var e = etat(sec);
    var figs = gal.querySelectorAll('figure');
    if (e) {
      var vus = 0;
      for (var i = 0; i < figs.length; i++) {
        var ok = visible(tagsDe(figs[i]), e);
        figs[i].style.display = ok ? '' : 'none';
        if (ok) vus++;
      }
      if (vus === 0) {
        for (var j = 0; j < figs.length; j++) figs[j].style.display = '';
      }
    }
    var duo = duoChoisi(sec);
    for (var k = 0; k < figs.length; k++) {
      if (estSolo(figs[k])) figs[k].style.display = duo ? '' : 'none';
    }
    construireVignettes(gal);
    try { gal.scrollTo({ left: 0, behavior: 'auto' }); } catch (err) { gal.scrollLeft = 0; }
  }

  /* ---------- vignettes ---------- */

  function construireVignettes(gal) {
    if (gal.__ul && gal.__ul.parentNode) gal.__ul.parentNode.removeChild(gal.__ul);
    gal.__ul = null;

    var vues = [];
    var toutes = gal.querySelectorAll('figure');
    for (var i = 0; i < toutes.length; i++) {
      if (toutes[i].style.display !== 'none') vues.push(toutes[i]);
    }
    gal.__vues = vues;
    if (vues.length < 2) return;

    var ul = document.createElement('ul');
    ul.className = 'dsk__vign';
    for (var j = 0; j < vues.length; j++) {
      (function (fig, n) {
        var src = fig.querySelector('img');
        var poster = null;
        if (!src) {
          var vid = fig.querySelector('video');
          if (vid) poster = vid.getAttribute('poster');
          if (!poster) return;
        }
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Média ' + (n + 1) + ' sur ' + vues.length);
        var im = document.createElement('img');
        im.loading = 'lazy';
        im.alt = '';
        im.src = src ? src.src : poster;
        b.appendChild(im);
        b.addEventListener('click', function () {
          gal.scrollTo({ left: fig.offsetLeft - gal.offsetLeft, behavior: 'smooth' });
        });
        li.appendChild(b);
        ul.appendChild(li);
      })(vues[j], j);
    }
    gal.parentNode.insertBefore(ul, gal.nextSibling);
    gal.__ul = ul;
    majVignettes(gal);
  }

  function majVignettes(gal) {
    var ul = gal.__ul, vues = gal.__vues || [];
    if (!ul) return;
    if (gal.scrollWidth <= gal.clientWidth + 4) { ul.classList.add('dsk__vign--off'); return; }
    ul.classList.remove('dsk__vign--off');
    var lis = ul.querySelectorAll('li');
    var k = Math.round(gal.scrollLeft / (gal.scrollWidth / Math.max(vues.length, 1)));
    if (k < 0) k = 0;
    if (k > lis.length - 1) k = lis.length - 1;
    for (var j = 0; j < lis.length; j++) lis[j].classList.toggle('actif', j === k);
  }

  function galeries(base) {
    var gals = base.querySelectorAll ? base.querySelectorAll('.dsk .gal') : [];
    for (var g = 0; g < gals.length; g++) {
      (function (gal) {
        if (gal.dataset.dskGal) return;
        if (gal.querySelectorAll('figure').length < 1) return;
        gal.dataset.dskGal = '1';

        var sec = gal.closest ? gal.closest('.dsk') : null;
        if (sec && sec.querySelector('input[name="dskO0"], input[name="dskO1"], input[name^="dskPack-"]')) {
          filtrer(gal, sec);
        } else {
          construireVignettes(gal);
        }

        var tick;
        gal.addEventListener('scroll', function () {
          if (tick) return;
          tick = requestAnimationFrame(function () { tick = null; majVignettes(gal); });
        }, { passive: true });
        window.addEventListener('resize', function () { majVignettes(gal); });
      })(gals[g]);
    }
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.name) return;
    var estOption = (el.name === 'dskO0' || el.name === 'dskO1');
    var estFormule = (el.name.indexOf('dskPack-') === 0);
    if (!estOption && !estFormule) return;
    var sec = el.closest ? el.closest('.dsk') : null;
    if (!sec) return;
    var gal = sec.querySelector('.gal');
    if (gal) filtrer(gal, sec);
  }, true);

  function lancer() { scanner(document); }
  if (document.readyState !== 'loading') lancer();
  else document.addEventListener('DOMContentLoaded', lancer);

  ['shopify:section:load', 'shopify:section:select', 'shopify:section:reorder', 'shopify:block:select'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { scanner(e.target || document); });
  });

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var ajouts = mutations[i].addedNodes;
        for (var j = 0; j < ajouts.length; j++) {
          if (ajouts[j].nodeType === 1) scanner(ajouts[j]);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  setTimeout(lancer, 800);
  setTimeout(lancer, 2500);
})();

/* ===========================================================
   Synchronisation des boutons d’achat secondaires
   (DSK 11 Offre, DSK 12 CTA final, barre sticky)
   avec la variante réellement sélectionnée sur la fiche.

   Correction principale : au chargement, on lit la valeur
   déjà cochée dans les inputs (checked = true) plutôt que
   de supposer que rien n’est sélectionné. Sans ça, les
   inputs présélectionnés (ex. Noir) étaient ignorés et
   le script ne faisait rien au chargement, laissant le
   formulaire sur la première variante Liquid (= Noir).
   =========================================================== */

(function () {
  if (window.__dskVarSync) return;
  window.__dskVarSync = true;

  function variantes() {
    var bloc = document.querySelector('script[id^="dskVars-"]');
    if (!bloc) return null;
    try { return JSON.parse(bloc.textContent); } catch (e) { return null; }
  }

  /* Lit la valeur cochée pour un groupe d’inputs donné.
     Retourne null si rien n’est coché, la valeur sinon.
     Ne retourne PAS null quand un input est présélectionné
     au chargement (checked natif du HTML). */
  function choisi(nom) {
    var el = document.querySelector('input[name="' + nom + '"]:checked');
    return el ? el.value : null;
  }

  function trouver(vars, v0, v1) {
    /* Correspondance exacte sur les options disponibles.
       Si v0 ou v1 est null (groupe absent), on ignore ce critère. */
    for (var i = 0; i < vars.length; i++) {
      var o = vars[i].o;
      if (v0 !== null && o[0] !== v0) continue;
      if (v1 !== null && o[1] !== v1) continue;
      return vars[i];
    }
    /* Fallback : si aucune correspondance exacte, retourner la
       première variante disponible pour éviter de rester sur Noir. */
    for (var j = 0; j < vars.length; j++) {
      if (vars[j].a) return vars[j];
    }
    return vars[0] || null;
  }

  function appliquer() {
    var vars = variantes();
    if (!vars || !vars.length) return;

    var v0 = choisi('dskO0');
    var v1 = choisi('dskO1');

    /* Si aucun input n’est encore coché (DOM pas prêt),
       on ne touche rien — on réessaiera sur événement change. */
    if (v0 === null && v1 === null) return;

    var cible = trouver(vars, v0, v1);
    if (!cible) return;

    var ids = document.querySelectorAll('[data-dsk-var-id]');
    for (var i = 0; i < ids.length; i++) ids[i].value = cible.id;

    var prix = document.querySelectorAll('[data-dsk-var-prix]');
    for (var j = 0; j < prix.length; j++) prix[j].textContent = cible.p;

    var barres = document.querySelectorAll('[data-dsk-var-barre]');
    for (var k = 0; k < barres.length; k++) {
      if (cible.r > 0) { barres[k].textContent = cible.c; barres[k].style.display = ''; }
      else { barres[k].style.display = 'none'; }
    }

    var ecos = document.querySelectorAll('[data-dsk-var-eco]');
    for (var m = 0; m < ecos.length; m++) {
      if (cible.r > 0) { ecos[m].textContent = '\u2212' + cible.r + ' %'; ecos[m].style.display = ''; }
      else { ecos[m].style.display = 'none'; }
    }

    var boutons = document.querySelectorAll('[data-dsk-var-bouton]');
    for (var n = 0; n < boutons.length; n++) boutons[n].disabled = !cible.a;
  }

  /* Déclenchement sur changement d’option. */
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.name) return;
    if (e.target.name !== 'dskO0' && e.target.name !== 'dskO1') return;
    appliquer();
  }, true);

  /* Déclenchement initial : on attend que le DOM soit prêt
     ET que les inputs soient rendus avec leur état coché. */
  function init() {
    /* Premier essai immédiat. */
    appliquer();
    /* Si les inputs n’étaient pas encore là, on réessaie
       une fois après le prochain rendu. */
    requestAnimationFrame(function () {
      appliquer();
      /* Dernière tentative après les scripts asynchrones de la fiche. */
      setTimeout(appliquer, 300);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  /* Rechargement éditeur. */
  ['shopify:section:load', 'shopify:section:select'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(appliquer, 100); });
  });
})();
